var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PaginationWrapper',{attrs:{"data":_vm.data},scopedSlots:_vm._u([{key:"default",fn:function({
    pageSize,
    setPageSize,
    setCurrentPage,
    total,
    currentPage,
    currentPageData,
  }){return [_c('WithManualPagination',{attrs:{"show-pagination":total > pageSize && !_vm.isLoading,"page-size":pageSize,"current-page":currentPage,"total":total},on:{"size-change":setPageSize,"current-change":setCurrentPage}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],class:['table-responsive', { raised: _vm.isRaised }]},[_vm._t("default",null,{"currentPageData":currentPageData})],2)])]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }